import React from 'react';
import {
  SearchInput,
  SelectInput,
  DateInput,
  TextInput,
  NullableBooleanInput,
  BooleanInput,
} from 'react-admin';
import { ORG_ID } from 'config';
import { ChannelState } from 'constants/channel-state.enum';
import { generateSelectOptions } from 'utils/filters-utils';
import { TAGS } from 'views/channel/constants';
import OrganizationReferenceInput from './OrganizationReferenceInput';
import UserReferenceInput from './UserReferenceInput';

// Create tags choices from the TAGS object
const tagsChoices = Object.values(TAGS).map((value) => ({ id: value, name: value }));

export const channelFilterInputs = [
  <SearchInput
    key="searchQuery"
    source="searchQuery"
    alwaysOn
    sx={{
      '& .MuiFilledInput-root': {
        minWidth: 110,
        width: 150,
      },
    }}
  />,
  <UserReferenceInput key="user" alwaysOn />,
  <SelectInput
    key="state"
    source="state"
    choices={generateSelectOptions(ChannelState, true)}
    alwaysOn
  />,
  !ORG_ID && <OrganizationReferenceInput key="org" alwaysOn />,
  <SelectInput
    source="tags"
    choices={tagsChoices}
    alwaysOn
  />,
  <SelectInput
    source="type"
    choices={[
      { id: 'long', name: 'Long' },
      { id: 'short', name: 'Short' },
      { id: 'mixed', name: 'Mixed' },
    ]}
  />,
  <TextInput source="source" label="UTM Source" />,
  <TextInput source="medium" label="UTM Medium" />,
  <DateInput
    key="createdAtFrom"
    source="createdAtFrom"
    locales="fa-IR"
    label="from"
    alwaysOn
    sx={{
      '& .MuiFilledInput-root': {
        minWidth: 110,
      },
    }}
  />,
  <DateInput
    key="createdAtEnd"
    source="createdAtEnd"
    label="to"
    alwaysOn
    sx={{
      '& .MuiFilledInput-root': {
        minWidth: 110,
      },
    }}
  />,
  <DateInput
    key="monetizedAtFrom"
    source="monetizedAtFrom"
    locales="fa-IR"
    label="Monetized from"
    sx={{
      '& .MuiFilledInput-root': {
        minWidth: 110,
      },
    }}
  />,
  <DateInput
    key="monetizedAtEnd"
    source="monetizedAtEnd"
    label="Monetized to"
    sx={{
      '& .MuiFilledInput-root': {
        minWidth: 110,
      },
    }}
  />,
  <DateInput
    key="acceptedAtFrom"
    source="acceptedAtFrom"
    locales="fa-IR"
    label="Accepted from"
    sx={{
      '& .MuiFilledInput-root': {
        minWidth: 110,
      },
    }}
  />,
  <DateInput
    key="acceptedAtEnd"
    source="acceptedAtEnd"
    label="Accepted to"
    sx={{
      '& .MuiFilledInput-root': {
        minWidth: 110,
      },
    }}
  />,
  <NullableBooleanInput
    key="regularCheckRequired"
    source="regularCheckRequired"
  />,
].filter(Boolean);
